/**
 * Lightly sanitizes an asset name by removing characters that are
 * invalid in Frame.io asset names.
 */
export function sanitizeAssetName(assetName: string) {
  return assetName.replace(/[#/]/g, '');
}
